/**
 * Please keep in sync with the `cookies.js` file in the `@bluheadless/server` package.
 * @see packages/server/src/utils/cookies.js
 */

import { isMatchStoreBySomething } from './match-store'
import escapeRegExp from 'lodash/escapeRegExp'

export const DIVIDER = '_|_'

export const formatStoreCookieName = (storeCode, cookieName) => {
	if (isMatchStoreBySomething()) {
		return `${cookieName}${DIVIDER}${storeCode}`
	} else {
		return cookieName
	}
}

export const formatGroupCookieName = (groupId, cookieName) => {
	if (isMatchStoreBySomething()) {
		return `${cookieName}${DIVIDER}${groupId}`
	} else {
		return cookieName
	}
}

export const storeRegexp = (storeCode) => new RegExp(`${escapeRegExp(DIVIDER)}${escapeRegExp(storeCode)}$`)
export const groupRegexp = (groupId) => new RegExp(`${escapeRegExp(DIVIDER)}${escapeRegExp(groupId)}$`)

export const reduceCookiesByStore = (cookies, storeCode) => {
	const storeRegExp = storeRegexp(storeCode)

	return isMatchStoreBySomething()
		? Object.keys(cookies).reduce((acc, cookieName) => {
				if (storeRegExp.test(cookieName)) {
					acc[cookieName.replace(storeRegExp, '')] = cookies[cookieName]
				}
				return acc
		  }, {})
		: cookies
}

export const reduceCookiesByGroup = (cookies, groupId) => {
	const groupRegExp = groupRegexp(groupId)

	return isMatchStoreBySomething()
		? Object.keys(cookies).reduce((acc, cookieName) => {
				if (groupRegExp.test(cookieName)) {
					acc[cookieName.replace(groupRegExp, '')] = cookies[cookieName]
				}
				return acc
		  }, {})
		: cookies
}
